export default __webpack_public_path__ + "static/media/t_wdt_c_1.24acf3eb.mp3";